import { Grid, Typography, TypographyProps } from "@mui/material";
import { ReactNode } from "react";
import Spacer from "./../Spacer";
import Toolbar, { ToolbarProps } from "./../Toolbar";

export interface FormSectionTitleProps extends ToolbarProps {
  title: string;
  titleProps?: TypographyProps;
  icon?: ReactNode;
}

export default function FormSectionTitle({
  title,
  titleProps,
  children,
  icon,
  ...props
}: FormSectionTitleProps) {
  return (
    <Grid sx={{ marginBottom: -2 }} item xs={12}>
      <Toolbar className="MuiFormSectiontitle" {...props}>
        {icon}
        <Typography variant="h5" {...titleProps}>
          {title}
        </Typography>
        {!!children && <Spacer right />}
        {children}
      </Toolbar>
    </Grid>
  );
}
